module.exports = __webpack_public_path__ + "static/media/CFTRchannel.2d0356a6.jpg";